import { baseUrl } from '../../constants'

export default async function fetchProjectsApi(offset, limit) {
  const requestUrl =
    `${baseUrl}/projects.json?` + `offset=` + offset + `&limit=` + limit
  const projects = await fetch(requestUrl)
  const projectsAsJson = await projects.json()
  return projectsAsJson
}
